const RESOLUTION_NUMBER_PATTERN = /\d{1,6}\s*[-/]\s*\d{1,6}(?!\d)/

function parseResolutionNumber(value: string) {
	const parts = value
		.split(/[-/]/)
		.map(part => part.trim())
		.filter(Boolean)
	if (parts.length !== 2) return null
	const [left, right] = parts
	if (!left || !right) return null
	const leftIsYear = left.length === 4 && /^(?:18|19|20|21)/.test(left)
	const rightIsYear = right.length === 4 && /^(?:18|19|20|21)/.test(right)
	const year = leftIsYear && !rightIsYear ? left : right
	const number = leftIsYear && !rightIsYear ? right : left
	return { number: String(Number(number)), year: year.length === 2 ? year : String(Number(year)) }
}

function numbersReferToSameResolution(left: string, right: string) {
	const parsedLeft = parseResolutionNumber(left)
	const parsedRight = parseResolutionNumber(right)
	if (!parsedLeft || !parsedRight || parsedLeft.number !== parsedRight.number) return false
	return (
		parsedLeft.year === parsedRight.year ||
		parsedLeft.year.endsWith(parsedRight.year) ||
		parsedRight.year.endsWith(parsedLeft.year)
	)
}

export function normalizeResolutionLikeCitationLeadIn(args: {
	leadIn: string
	canonicalNumber: string
	labelPattern: string
}) {
	const pattern = new RegExp(
		`(\\b(?:${args.labelPattern})\\s+(?:n(?:[°ºo]|\\.?)\\s*)?)(\\*\\*)?(${RESOLUTION_NUMBER_PATTERN.source})(\\*\\*)?(?![\\s\\S]*\\b(?:${args.labelPattern})\\b)`,
		'i',
	)
	return args.leadIn.replace(
		pattern,
		(match, prefix: string, openingBold = '', citedNumber: string, closingBold = '') =>
			numbersReferToSameResolution(citedNumber, args.canonicalNumber)
				? `${prefix}${openingBold}${args.canonicalNumber}${closingBold}`
				: match,
	)
}
